import { Link } from 'react-router-dom'
import { Home, AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <AlertCircle className="mx-auto h-12 w-12 text-destructive" />
          <h2 className="mt-6 text-3xl font-semibold tracking-tight text-foreground">
            404 - Página não encontrada
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            A página que você está procurando não existe ou foi removida.
          </p>
        </div>
        <div>
          <Button asChild>
            <Link to="/">
              <Home className="size-4" aria-hidden="true" />
              Voltar ao início
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}